import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { DatovkaApiType } from '@gov-nx/api';
import { useAuthorizationConsentYupSchema } from '@gov-nx/core/hooks';
import {
	dataBoxParams,
	useDataBoxShape,
	useIcNumberShape,
} from '@gov-nx/utils/common';
import type { FormData } from './service.types';

export interface FormInstanceProps {
	dataBoxTypes: DatovkaApiType['typSchranky'][];
	isLowAuthorization: boolean;
}

export function FormInstance({
	dataBoxTypes,
	isLowAuthorization,
}: FormInstanceProps): FormDefinition<FormData> {
	const { getDataBoxShape, getDataBoxDefaultValues } = useDataBoxShape({
		types: dataBoxTypes,
	});
	const { getIcNumberShape } = useIcNumberShape();
	const consentSchema = useAuthorizationConsentYupSchema({
		isConsentRequired: isLowAuthorization,
	});

	const formSchema = yup
		.object({
			...getDataBoxShape({ isRequired: true }),
			ico: getIcNumberShape({
				isRequired: true,
			}),
			druhVypisu: yup.string().oneOf(['UPLNY', 'PLATNE']).optional(),
		})
		.shape({ __souhlas: consentSchema })
		.required();

	const formMethods = useGovForm<FormData>({
		formSchema,
		defaultValues: {
			...getDataBoxDefaultValues(),
			ico: undefined,
			druhVypisu: 'UPLNY',
		},
	});

	return getFormDefinition({ formMethods, formSchema });
}

export function prepareSubmitData(formData: FormData) {
	return {
		params: dataBoxParams(formData),
		body: {
			typVypisu: 'VEREJNY_REJSTRIK',
			data: {
				ico: formData.ico,
				druhVypisu: formData.druhVypisu,
			},
		},
	};
}
